import React from 'react'
import { PrimaryButton, Box } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useAuthenticationLocaleText } from '../../text-localisation'
import { getProviderLogo } from './authUtils'
import { OidcProvider } from './types'
import { trackSocialLoginOptionClick } from './tracking'

const StyledButton = styled(PrimaryButton)`
  ${s({
    color: 'colorTextBody',
    paddingTop: 0,
    paddingBottom: 0,
    bgcolor: 'colorBackground02',
    border: 0,
    boxShadow: 0,
  })}
  min-height: 52px;
  &:not(:disabled):hover {
    ${s({ color: 'colorTextBody', bgcolor: 'colorBackground04', boxShadow: 0 })}
  }
  &:not(:disabled):focus {
    ${s({ color: 'colorTextBody', bgcolor: 'colorBackground04' })}
  }
  & div {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & span {
    align-items: center;
  }
`

export const SocialLoginButton: React.FC<{
  provider: OidcProvider
  onClick: (provider: OidcProvider) => Promise<void>
}> = ({ provider, onClick }) => {
  const localiseText = useAuthenticationLocaleText()

  const onSocialLoginButtonClick = () => {
    trackSocialLoginOptionClick(provider.id)
    onClick(provider)
  }

  return (
    <StyledButton width={1} onClick={onSocialLoginButtonClick} type="button">
      <Box style={{ minWidth: 40 }}>
        <img
          src={getProviderLogo(provider.id)}
          role="presentation"
          alt={`${provider.id} logo`}
        />
      </Box>
      {`${localiseText('auth_wizard.social_login.button')}${provider.name}`}
    </StyledButton>
  )
}
